// extracted by mini-css-extract-plugin
export var colored = "ButtonLink-module--colored--e78fb";
export var headerFix = "ButtonLink-module--headerFix--ff969";
export var root = "ButtonLink-module--root--bc341";